/**
 * Builds an FinancialProduct JSON-LD schema
 * @param {Object} options - Configuration options for the schema
 * @returns {Object|null} the schema object
 */
export function buildFinancialProductSchema(options = {}) {
    const { id, name, description } = options

    if (!id) {
        return null
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "FinancialProduct",
        "@id": id
    };

    if (name) {
        schema.name = name
    }

    if (description) {
        schema.description = description
    }

    return schema
}
